import React from 'react';

import { Logger } from 'services/logger';

export const ONETRUST_CATEGORIES = {
  strictlyNecessary: 'C0001',
  performance: 'C0002',
  functional: 'C0003',
  targeting: 'C0004',
  socialMedia: 'C0005',
};

const COOKIE_CONSENT_NAME = 'OptanonConsent';
const COOKIE_CONSENT_REGEX = /groups=([^&]*)/;

export class OneTrustService {
  static getOneTrustContestSetupScript() {
    const oneTrustConsent = `
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }

      function getConsentState(category, groups) {
        return groups.includes(category) ? 'granted' : 'denied';
      }

      function setGtagDefaultConsent(activeGroups) {
        window.gtag('consent', 'default', {
          ad_storage: getConsentState('${ONETRUST_CATEGORIES.targeting}', activeGroups),
          ad_user_data: getConsentState('${ONETRUST_CATEGORIES.targeting}', activeGroups),
          ad_personalization: getConsentState('${ONETRUST_CATEGORIES.targeting}', activeGroups),
          analytics_storage: getConsentState('${ONETRUST_CATEGORIES.performance}', activeGroups),
          functionality_storage: getConsentState('${ONETRUST_CATEGORIES.functional}', activeGroups),
          personalization_storage: getConsentState('${ONETRUST_CATEGORIES.strictlyNecessary}', activeGroups),
          security_storage: getConsentState('${ONETRUST_CATEGORIES.strictlyNecessary}', activeGroups),
          'wait_for_update': 500,
        });
      }

      window.addEventListener('OneTrustGroupsUpdated', event => {
        setGtagDefaultConsent(event.detail);
      });

      function OptanonWrapper() {
        if (OnetrustActiveGroups.indexOf('${ONETRUST_CATEGORIES.performance}') != -1 && OnetrustActiveGroups.indexOf('${ONETRUST_CATEGORIES.targeting}') != -1) {
          gtag('consent', 'update', {
            'analytics_storage': 'granted',
            'ad_storage': 'granted'
          });
        } else if (OnetrustActiveGroups.indexOf('${ONETRUST_CATEGORIES.performance}') != -1) {
          gtag('consent', 'update', { 'analytics_storage': 'granted' });
        } else if (OnetrustActiveGroups.indexOf('${ONETRUST_CATEGORIES.targeting}') != -1) {
          gtag('consent', 'update', { 'ad_storage': 'granted' });
        };
      }
    `;

    return (
      <script
        type="text/javascript"
        key={`one-trust-consent`}
        id={`gatsby-one-trust-consent`}
        dangerouslySetInnerHTML={{ __html: oneTrustConsent }}
      />
    );
  }

  static getOneTrustSDKScript() {
    return (
      <script
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        type="text/javascript"
        data-domain-script={process.env.ONETRUST_DOMAIN_ID}
      />
    );
  }

  static toggleModal() {
    window.OneTrust?.ToggleInfoDisplay?.();
  }

  static checkConsent(consent) {
    return new Promise((resolve) => {
      const cookieConsent = OneTrustService.getCookieConsent();
      if (cookieConsent !== undefined) {
        resolve(cookieConsent.includes(consent));
        return;
      }

      if (typeof window.OnetrustActiveGroups !== 'undefined') {
        resolve(window.OnetrustActiveGroups.includes(consent));
        return;
      }

      window.addEventListener(
        'OneTrustGroupsUpdated',
        (event) => {
          resolve(event.detail?.includes(consent));
        },
        { once: true }
      );
    });
  }

  static getCookieConsent() {
    try {
      const cookie = Cookies.get(COOKIE_CONSENT_NAME);
      const match = cookie?.match(COOKIE_CONSENT_REGEX);
      if (!match) return;

      return match[1]
        .split(',')
        .filter((pair) => pair.endsWith(':1'))
        .map((pair) => pair.split(':')[0])
        .join(',');
    } catch (e) {
      Logger.warn(JSON.stringify(e));
    }
  }
}
